<div class="modal-header">
  <h5 class="modal-title">{{'WIZARD.ADD_NEW_ACCOUNT'|translate}}</h5>
  <span
    class="btn btn-icon btn-sm btn-active-light-primary" aria-label="Close"
    (click)="closeModal()"
    inlineSVG="./assets/media/icons/duotune/arrows/arr011.svg"
  ></span>
</div>
<div class="modal-body py-12 px-7 px-lg-18">
  <app-wizard-account [initialType]="accountType"></app-wizard-account>
</div>
